<template>
    <div
        class="top-navigation">

        <a
            class="top-navigation__logo-link"
            :href="landingUrl"
            :title="$t('to-the-landing-page')">
            <img
                class="top-navigation__logo"
                alt="Bloombup"
                width="60"
                src="@/assets/images/logos/Logo-Icon.png" />
        </a>

        <template v-if="loggedUser">
            <div class="top-navigation__mobile--footer">
                <template v-if="!isMobileMenuOpen">
                    <button
                        @click="toggleMobileMenu"
                        class="hamburger-button button button--transparent">
                        <span class="sr-only">{{ $t("open-menu") }}</span>
                        <div class="hamburger-button__line"></div>
                        <div class="hamburger-button__line"></div>
                        <div class="hamburger-button__line"></div>
                    </button>
                </template>
                <template v-else>
                    <button
                        @click="toggleMobileMenu"
                        class="hamburger-button button--circle button--transparent">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9.072"
                            height="9.072"
                            viewBox="0 0 9.072 9.072"><path
                                d="M.775 8.369a.693.693 0 0 1 0-.98L7.393.775a.693.693 0 0 1 .98 0 .693.693 0 0 1 0 .98L1.755 8.369a.693.693 0 0 1-.98 0z"
                                fill="#250954"
                                stroke="#250954"
                                stroke-linecap="round"
                                stroke-miterlimit="10"/><path
                                    d="M.775.775a.693.693 0 0 1 .98 0l6.614 6.618a.693.693 0 0 1 0 .98.693.693 0 0 1-.98 0L.775 1.755a.693.693 0 0 1 0-.98z"
                                    fill="#250954"
                                    stroke="#250954"
                                    stroke-linecap="round"
                                    stroke-miterlimit="10"/></svg>
                    </button>
                </template>

            </div>


            <div
                v-if="isMobile"
                id="topNavigationMobileTools"
                class="top-navigation__mobile-tools">
                <div
                    class="top-navigation__data-select"
                    v-if="availableDatas && !$route.meta.hideUsersSelectionInTopNav">
                    <field-select
                        name="dataSelection"
                        id="topNavDataSelection"
                        input-label-id="top-nav-data-selection-label"
                        :value="currentDataId"
                        @update-value="updateDataSelection"
                        :options="availableDatas" />
                </div>
                <button
                    v-if="$route.name === 'in-depth'"
                    @click="clickMobileHelpButton"
                    type="button"
                    class="button button--transparent">
                    <img
                        src="@/assets/images/icons/icon-help-disk.svg"
                        :alt="$t('help')">
                </button>
            </div>

            <div
                class="top-navigation__panel"
                :class="{'open': isMobileMenuOpen}">

                <div class="top-navigation__panel-content">

                    <router-link
                        v-if="loggedUser"
                        @click.native="closeMobileMenu"
                        to="/user/profile"
                        class="top-navigation__user-info">
                        <div class="person-circle top-navigation__user-avatar">
                            {{ loggedUser.fname.substring(0, 2).toLowerCase() }}
                        </div>
                        <p class="top-navigation__user-name">{{ loggedUser.fname.toLowerCase() }}</p>
                    </router-link>

                    <nav
                        v-if="isMobile || $route.name !== 'dashboard'"
                        name="top-navigation-menu"
                        class="link-menu">
                        <ul class="link-menu__list">
                            <li
                                v-for="(item, index) in navigationItems"
                                :key="`top-navigation-menu-item-${index}`"
                                class="link-menu__list-item">

                                <template v-if="item.meta.isDisabled">
                                    <span
                                        class="link-menu__list-link--disabled"
                                        :title="$t('available-soon')">
                                        <span class="link-menu__link-label">
                                            {{ capitalize($t(item.name)) }}
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="item.meta.isPremiumOnly && !loggedUser.userpremium">
                                    <span
                                        class="link-menu__list-link--disabled"
                                        :title="$t('feature-reserved-to-premium')">
                                        <span class="link-menu__link-label">
                                            {{ capitalize($t(item.name)) }}
                                        </span>
                                    </span>
                                </template>
                                <template v-else>
                                    <router-link
                                        @click.native="closeMobileMenu"
                                        class="link-menu__list-link"
                                        :class="(routeIsActive(item)) ? 'link-menu__list-link--active' : false"
                                        :to="item.path">
                                        <span class="link-menu__link-label">{{ capitalize($t(item.name)) }}</span>
                                    </router-link>
                                </template>

                            </li>
                            <template v-if="isMobile">
                                <li class="link-menu__list-item link-menu__list-item--top-sep">
                                    <router-link
                                        @click.native="closeMobileMenu"
                                        class="link-menu__list-link"
                                        :class="(routeIsActive({name: 'profile'})) ? 'link-menu__list-link--active' : false"
                                        to="/user/profile">
                                        <span class="link-menu__link-label">{{ $t("my-profile") }}</span>
                                    </router-link>
                                </li>
                                <li class="link-menu__list-item">
                                    <router-link
                                        @click.native="closeMobileMenu"
                                        class="link-menu__list-link"
                                        :class="(routeIsActive({name: 'circles'})) ? 'link-menu__list-link--active' : false"
                                        to="/circles">
                                        <span class="link-menu__link-label">{{ $t("my-circles") }}</span>
                                    </router-link>
                                </li>
                                <li class="link-menu__list-item">
                                    <router-link
                                        @click.native="closeMobileMenu"
                                        class="link-menu__list-link"
                                        to="/logout">
                                        <span class="link-menu__link-label">{{ $t("logout") }}</span>
                                    </router-link>
                                </li>
                            </template>
                        </ul>
                    </nav>

                    <div
                        v-if="!isMobile"
                        id="dataSelectWrapperDesktop">
                        <div
                            class="top-navigation__data-select"
                            v-if="availableDatas && !$route.meta.hideUsersSelectionInTopNav">
                            <field-select
                                name="dataSelection"
                                id="topNavDataSelection"
                                input-label-id="top-nav-data-selection-label"
                                :value="currentDataId"
                                @update-value="updateDataSelection"
                                :options="availableDatas" />
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <dropdown
            class="top-navigation__user-link"
            v-if="loggedUser"
            trigger-style="button button--transparent top-navigation__user-link-button"
            :trigger-icon-visible="false"
            :trigger-title="capitalize(loggedUser.fname)"
            :header-title="$t('profile')"
            body-direction="right"
        >
            <template slot="triggerTitle">
                <span class="button__label">
                    {{ capitalize(loggedUser.fname) }}
                </span>
                <svg
                    class="button__icon top-navigation__user-link-icon"
                    width="38"
                    height="38"
                    viewBox="0 0 38 38"
                    xmlns="http://www.w3.org/2000/svg"><g
                        transform="translate(1 1)"
                        fill="none"
                        fill-rule="evenodd"><path d="M4.004 29.32A17.925 17.925 0 0 1 0 18C0 8.059 8.059 0 18 0s18 8.059 18 18c0 4.289-1.5 8.228-4.004 11.32.003-.106.004-.213.004-.32 0-5.462-3.628-10.137-8.768-12.062-1.309 1.261-3.169 2.049-5.232 2.049s-3.923-.788-5.232-2.049C7.628 18.863 4 23.538 4 29c0 .107.001.214.004.32z"/><circle
                            cx="18"
                            cy="18"
                            r="18"/><ellipse
                                cx="18"
                                cy="12.494"
                                rx="7.177"
                                ry="6.494"/></g></svg>
            </template>

            <template #default>
                <span
                    id="domainsListInstruction"
                    class="sr-only">{{ $t("select-at-least-1-domain") }}</span>
                <ul
                    class="list--unstyled"
                    aria-labelledBy="domainsListInstruction">
                    <li>
                        <router-link
                            class="dropdown__link"
                            to="/user/profile">
                            {{ $t("my-profile") }}
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            class="dropdown__link"
                            to="/circles">
                            {{ $t("my-circles") }}
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            class="dropdown__link"
                            to="/logout">
                            {{ $t("logout") }}
                        </router-link>
                    </li>
                </ul>
            </template>
        </dropdown>
    </div>
</template>

<script>
// @ is an alias to /src

import Vue from "vue";

import Dropdown from "@/components/dropdown/Dropdown.vue";
import FieldSelect from "@/components/forms/FieldSelect.vue";

export default {
    name: "TopNavigation",
    components: {
        "Dropdown": Dropdown,
        "FieldSelect": FieldSelect
    },
    props: {
    },
    data() {
        return {
            isMobile: false,
            isMobileMenuOpen: false,
            landingUrl: process.env.VUE_APP_LANDIND_PAGE_URL,
        };
    },
    computed: {
        // currentDataId
        // Current data (user of group) id to display
        currentDataId() {
            return this.$store.getters["globalModule/getCurrentDataId"];
        },
        // getAvailableDatas
        // Current available datas to selection
        availableDatas() {
            return this.$store.getters["globalModule/getAvailableDatas"];
        },
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        isAModalOpen() {
            return this.$store.getters["modalModule/isModalOpen"];
        },
        windowScrollBarWidth() {
            return this.$store.getters["modalModule/windowScrollBarWidth"];
        },
        // enabledNavigationItems() {
        //     return this.navigationItems.filter((x) => x.enabled);
        // },
        navigationItems() {
            const items = this.$router.options.routes.filter((route) => {
                if (route.meta && route.meta.isInTopNavigation) {
                    return true;
                }

                return false;
            });

            return items;
        }
    },
    watch: {
        isAModalOpen(newValue) {
            if (newValue === true) {
                this.handleModalOpen();
            } else {
                this.handleModalClose();
            }
        }
    },
    mounted: function() {
        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("to-desktop", () => {
            this.isMobile = true;
        }, () => {
            this.isMobile = false;
        });

    },
    methods: {
        toggleMobileMenu() {
            if (this.isMobileMenuOpen) {
                this.closeMobileMenu();
            } else {
                this.openMobileMenu();
            }
        },
        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        },
        openMobileMenu() {
            this.isMobileMenuOpen = true;
        },
        handleModalOpen: function() {
            // Add padding right to the topNavigation to avoid content shifting to the right when scrollbar disapear (on a modal opening)
            this.$el.style.paddingRight = this.windowScrollBarWidth + "px";

        },
        handleModalClose: function() {
            // Reset the padding (on a modal close)
            this.$el.style.paddingRight = null;
        },
        clickMobileHelpButton: function() {
            const currentRoute = this.$route.name;

            if (currentRoute === "match") {
                this.$store.commit("modalModule/setVisibilityMatchHelpModal", true);
            }
        },
        routeIsActive(navigationItem) {
            const currentRouteName = this.$route.name;

            if (currentRouteName === navigationItem.name) {
                return true;
            }


            if (navigationItem.children) {

                const childrenIndex = this.getObjetIndexByKey(navigationItem.children, "name", currentRouteName);

                if (childrenIndex > -1) {
                    return true;
                }
            }

            return false;

        },
        updateDataSelection(value) {
            this.$store.commit("globalModule/setCurrentDataId", value);
        }
    }
};
</script>
